import styled, { css } from 'styled-components';
import { PageTopControlsPosition } from '@/components/PageTopControls/PageTopControls.types';
import { HEADER_HEIGHT } from '@/components/Header/Header.constants';

export const PageTopControlsBox = styled.div<{
  $isVisible: boolean;
  $fixedTopControlsHeight: number;
  $position: PageTopControlsPosition;
}>`
  background-color: ${({ theme }) => theme.palette.primary.background};
  position: ${({ $position }) => $position};
  top: 0;
  padding-top: ${({ theme }) => (theme.isWebView ? `${HEADER_HEIGHT}px` : 0)};
  z-index: 10;

  ${({ $isVisible, $position, $fixedTopControlsHeight }) =>
    $position === 'fixed' &&
    css`
      left: 0;
      right: 0;
      top: -${$fixedTopControlsHeight}px;
      transition: transform 0.3s;
      ${() =>
        $isVisible &&
        css`
          transform: translateY(100%);
        `}
    `}
`;

export const PageTopControlsGutter = styled.div<{
  $topControlsHeight: number;
}>`
  height: ${({ $topControlsHeight }) => `${$topControlsHeight}px`};
`;
